import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { INote, INotesResponse } from "./index.type";

const useGetBarriersPdfPage = ({ billingId }: { billingId?: string }) => {
  const [barriersData, setBarriersData] = React.useState<INote[]>();

  const { loading: getAllDataLoading, makeApiCall } = useApi({
    method: "GET",
    url: `/rtm/summary-page/cron/pdf/barriers/${billingId}`,
    preAuth: true,
  });

  const getBarriersData = async () => {
    const { response, error } = await makeApiCall<undefined, INotesResponse>();

    if (response?.status === "success") {
      setBarriersData(response.data);
    }

    if (error) {
      toast.error(error.msg);
      setBarriersData(undefined);
    }
  };

  React.useEffect(() => {
    getBarriersData();
  }, []);

  return { getAllDataLoading, barriersData };
};

export default useGetBarriersPdfPage;
